import { Account } from './types';
import { ROLES } from '../role/types';

export const isDriver = (a: Account) => a.roles.includes(ROLES.DRIVER);